/**
 * Close Cashier Modal Component - Using StandardModal
 */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../../components/ui/modal';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { StopCircle } from 'lucide-react';

export function CloseCashierModal({ open, onOpenChange, cashier, onConfirm, formatCurrency, loading }) {
  const { t } = useTranslation();
  const [amount, setAmount] = useState('');

  const handleConfirm = () => {
    onConfirm({ final_amount: parseFloat(amount) || 0 });
    setAmount('');
  };

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title={t('cashiers.closeCashier')}
      description={`Fechando: ${cashier?.name}`}
      size="sm"
      footer={
        <>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('common.cancel')}
          </Button>
          <Button onClick={handleConfirm} disabled={loading} data-testid="confirm-close-btn">
            <StopCircle className="h-4 w-4 mr-2" />
            {t('cashiers.closeCashier')}
          </Button>
        </>
      }
    >
      <div className="space-y-4">
        <div className="p-3 bg-muted rounded-lg space-y-1">
          <div className="flex justify-between text-sm">
            <span>{t('cashiers.initialAmount')}</span>
            <span className="font-mono">{formatCurrency(cashier?.initial_amount)}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span>Saldo Esperado</span>
            <span className="font-mono font-semibold">{formatCurrency(cashier?.current_amount)}</span>
          </div>
        </div>
        <div className="space-y-2">
          <Label htmlFor="closeAmount">Valor Contado no Caixa</Label>
          <Input
            id="closeAmount"
            type="number"
            step="0.01"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="0.00"
            data-testid="close-amount-input"
          />
        </div>
      </div>
    </Modal>
  );
}

export default CloseCashierModal;
